import React, { useEffect, useState } from 'react'
import '../table.css'
import { DataGrid } from '@mui/x-data-grid'
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CircularProgress from '@mui/material/CircularProgress';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import {
    formatCreatedAt,
    fetchData,
    handleDeleteActionClick,
    handleAddOpen,
    handleEditOpen,
    handleEditClose,
    handleAddClose
} from '../../helpers/public';
import { photoDataGrid, universityDataGrid } from '../../constant/dataGrid';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import AddQuestions from '../questions/AddQuestions';
import AddPhoto from './AddPhoto';
import EditPhoto from './EditPhoto';
import ShowPhoto from './ShowPhoto';


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const messages = {
    a: "الرجاء اختيار جامعة",
    c: "هل انت متاكد انك تريد الحذف",
    b: 'خطأ في العملية'
}
const url = `${process.env.REACT_APP_URL}/houdix/seen/admin/photos`

const Photos = () => {

    const [cookies, setCookie, removeCookie] = useCookies(['token']);

    const [message, setMessage] = useState("")
    const [open, setOpen] = React.useState(false);
    const [addOpen, setAddOpen] = React.useState(false);
    const [editOpen, setEditOpen] = React.useState(false);
    const [showOpen, setShowOpen] = React.useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleAddOpen = () => setAddOpen(true);
    const handleAddClose = () => setAddOpen(false);
    const handleEditOpen = () => setEditOpen(true);
    const handleEditClose = () => setEditOpen(false);
    const handleShowOpen = () => setShowOpen(true);
    const handleShowClose = () => setShowOpen(false);

    const handleAddActionClick = () => {
        handleAddOpen(setAddOpen);
    };

    const handleEditActionClick = (row) => {
        setSelectedItem(row)
        handleEditOpen();
    };

    const handleShowActionClick = (row) => {
        setSelectedItem(row)
        handleShowOpen();
    };

    const handleClickAlert = () => {
        setOpen(true);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const handleDeleteActionClick = (selectedRows, setMessage, handleClickAlert, messages, url) => {
        const token = cookies['token']
        if (selectedRows.length === 0) {
            alert(messages.a);
            return;
        }
        const confirmation = window.confirm(messages.c);
        if (confirmation) {
            axios
                .delete(url, {
                    data: { ids: selectedRows },
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                .then((response) => {
                    if (response.status === 200) {
                        setMessage("تمت العملية بنجاح")
                        handleClickAlert()
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setMessage(messages.b);
                    handleClickAlert()
                });
        }
    };

    useEffect(() => {
        const token = cookies['token']
        // fetchData(url, setRows, setIsLoading, cookies);
        const fetchData = async (url, setRows, setIsLoading, setCsvRows, token) => {
            try {
                const response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setRows(response.data);
                setIsLoading(false);
                if (setCsvRows) {
                    setCsvRows(response.data)
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData(url, setRows, setIsLoading, cookies, token)
    }, [open]);

    if (isLoading) {
        return (
            <div style={{ display: 'flex', height: "100vh", justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <>
            <div className='container'>
                <div className='title'>
                    <div>
                        <button onClick={handleAddActionClick}>إضافة</button>
                        {selectedRows.length !== 0 && <button onClick={() => { handleDeleteActionClick(selectedRows, setMessage, handleClickAlert, messages, url) }}>حذف</button>}
                    </div>
                    <div>
                        <span className='main-title'>الصور</span>
                    </div>
                </div>
                <div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <div style={{ height: 'calc(100vh - 130px)', width: '100%' }}>
                            <DataGrid
                                sx={{ ".MuiDataGrid-columnHeaderTitle": { fontWeight: "700" }, ".MuiSvgIcon-root": { color: "#240259" }, "&.MuiDataGrid-cell": { height: "30px" }, '.MuiTablePagination-root': { direction: 'ltr' } }}
                                hideFooter={false}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 9,
                                        },
                                    },
                                }}
                                rows={rows}
                                columns={photoDataGrid(formatCreatedAt, ModeEditIcon, handleEditActionClick, handleShowActionClick)}
                                checkboxSelection
                                pageSizeOptions={[9]}
                                onRowSelectionModelChange={(itm) => {
                                    setSelectedRows(rows.map(row => row.url))
                                }}
                                disableRowSelectionOnClick
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'odd' : 'even'
                                }
                                style={{ border: '5px solid #DFDFDF', borderRadius: '32px 32px 0 0 ', direction: "rtl", borderBottom: 'none', backgroundColor: "#FFFFFF" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {addOpen && <AddPhoto handleClose={() => handleAddClose(setAddOpen)} handleClickAlert={handleClickAlert} setMessage={setMessage} />}
            {showOpen && <ShowPhoto handleClose={() => handleShowClose()} selectedRows={selectedItem} handleClickAlert={handleClickAlert} setMessage={setMessage} />}
            {editOpen && <EditPhoto handleClose={() => handleEditClose(setEditOpen)} selectedRows={selectedItem} handleClickAlert={handleClickAlert} setMessage={setMessage} />}
            <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%', backgroundColor: '#240259' }}>
                    {message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default Photos
